import React, {Component} from "react";
import CanvasDraw from "react-canvas-draw";
import GeneralHeader from "components/Headers/GeneralHeader";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Input,
    Container,
    Row,
    Col,
    Label
} from "reactstrap";
import axios from 'axios';
import Loader from 'react-loader-spinner';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactPlayer from 'react-player'

class VideoPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
           
            upload_id: this.props.match.params.upload_id,            
            student: {},
            annotation: '',
            student_id: '',
            submission_total:0,
            submission_mark:0
        };
        this.getVideoUrl = this.getVideoUrl.bind(this);
       this.handleChange = this.handleChange.bind(this);
       this.saveAsessmentResult = this.saveAsessmentResult.bind(this);

    }
    componentDidMount() { // let's change the color randomly every 2 seconds. fun!
        //console.log('Check Scriptview state', this.state);
        this.getVideoUrl();
    }

    handleChange(event){
      const target = event.target;
      const value =  target.value;
      const name = target.name;
  
      this.setState({
        [name]: value
      });
    }

   
    getVideoUrl() { 
        //console.log('Playing video');       
        let cur = this;
        axios.get('https://admin.thinkdigitalacademy.org/api/get-video-url/' + cur.props.match.params.upload_id, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            console.log('current vid', res.data);
            this.setState({video_url: res.data.upload.directory,submission_total:res.data.assessment.total});
        }).catch(error => {
            //console.log('error', error);
            toast('An error occurred while reading video from url', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.ERROR
            });
        });
    }

    saveAsessmentResult(){
        let cur = this;
        const data = {
          submission_total: cur.state.submission_total,
          submission_mark: cur.state.submission_mark,
          submission_id: cur.state.upload_id, 
          result_type: 'video'      
      };
  
      if( cur.state.submission_total>0){
          axios({
              headers: {
                  'content-type': 'application/json'
              },
              method: 'post',
              url: 'https://admin.thinkdigitalacademy.org/api/submit-marker-result',
              data: data
          }).then(res => {
              //console.log(res);
              //console.log(res.data);
              //console.log('save temp scripted', res.data);
              toast(res.data.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                type: toast.TYPE.SUCCESS
            });
          }).catch(error => {
              let error_result = error.response;
              toast(error_result.data.error, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  type: toast.TYPE.ERROR
              });
          });
      }else{
          toast("Please enter a valid total. Total mark can not be less than or equal to zero", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: toast.TYPE.ERROR
          });
      }
    }

    render() {
        return (
            <div>
                <ToastContainer position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover/>
                <ToastContainer/>
                <GeneralHeader/>
                <Container className="mt--7" fluid>
                    <Row>
                        <Col className="order-xl-1" xl="12">
                            <Card className="bg-secondary shadow">
                                <CardHeader className="bg-white border-0">
                                    <Row>
                                        <Col sm={1}>
                                    <Input onChange={this.handleChange} type="number" name="submission_mark" value={this.state.submission_mark} placeholder='Mark Obtained' type='text'></Input>
                                </Col>
                                <Col sm={1}>
                                    <Input onChange={this.handleChange} type="number" name='submission_total' value={this.state.submission_total} placeholder='Total Mark' type='text'></Input>
                                </Col>
                                <Col md={1}>
                                <Button size="sm" color="success" type="button"
                                      onClick={this.saveAsessmentResult} >
                                        Save
                                    </Button>
                                </Col> </Row>
                                    
                                </CardHeader>
                                <CardBody> {
                                    <Row>
                                        <Col lg={12}>
                                        <ReactPlayer controls={true} url={'//think-digital-production.s3.eu-west-1.amazonaws.com/'+this.state.video_url} />
                                    
                                        </Col>
                                       </Row>
                                } </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </Container>

            </div>
        );
    }
};
export default VideoPlayer;
